import React from 'react';
import { useLeadIntel } from '../../context/LeadIntelContext';
import { useCRM } from '../../context/CRMContext';
import SafeIcon from '../../common/SafeIcon';
import { useNavigate } from 'react-router-dom';

const HotLeadsWidget = () => {
  const { scores } = useLeadIntel();
  const { companies } = useCRM();
  const navigate = useNavigate();

  const hotLeads = scores
    .filter(s => s.band === 'Hot')
    .map(s => ({
      ...s,
      company: companies.find(c => c.company_id === s.company_id)
    }))
    .filter(item => item.company); // Ensure company exists

  if (hotLeads.length === 0) return null;

  return (
    <div className="bg-gradient-to-br from-rose-50 to-orange-50 p-6 rounded-[2rem] border border-rose-100 shadow-sm mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-white rounded-lg text-rose-500 shadow-sm">
          <SafeIcon icon="🔥" />
        </div>
        <h3 className="text-lg font-black text-rose-900">Hot Leads</h3>
      </div>
      <div className="space-y-3">
        {hotLeads.map(lead => (
          <div 
            key={lead.company_id} 
            onClick={() => navigate(`/companies/${lead.company_id}`)}
            className="bg-white p-4 rounded-xl border border-rose-100 shadow-sm hover:shadow-md transition-all cursor-pointer flex justify-between items-center"
          >
            <div>
              <h4 className="font-bold text-slate-900">{lead.company.name}</h4>
              <p className="text-xs text-slate-500">{lead.reasons[0] || 'Høy aktivitet'}</p>
            </div>
            <div className="text-right">
              <span className="text-xl font-black text-rose-600">{lead.score}</span>
              <p className="text-[9px] font-bold text-rose-400 uppercase">Poeng</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotLeadsWidget;